import { InputBlock } from '@coast/schemas/index';
import { useCallback, useMemo } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { FileUpload } from '@shared/components/blocks/types';
import { renderError } from './input';
import { FileInput } from './inputFile/FileInput';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockImage({ block }: Props) {
  const { setFieldValue, values, errors } = useCardFormContext();

  const error = errors[block.name];
  const imageUri: string = values[block.name];
  const acceptedContentTypes = useMemo<string[] | undefined>(
    () => ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'],
    [],
  );

  const onFileAdded = useCallback((file: FileUpload) => {
    const newValue = file.url;
    setFieldValue(block.name, newValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFileRemoved = useCallback((_: FileUpload) => {
    setFieldValue(block.name, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FileInput
        label={block.label}
        error={!!error}
        placeholder={block.placeholder}
        icon={block.icon}
        acceptedContentTypes={acceptedContentTypes}
        onFileAdded={onFileAdded}
        onFileRemoved={onFileRemoved}
        files={useMemo(
          () => (!!imageUri ? [{ name: '', contentType: 'image/unknown', url: imageUri }] : []),
          [imageUri],
        )}
      />
      {renderError(block)}
    </>
  );
}
